import React from "react";
import { useTranslation } from "react-i18next";
import FacesDescriptionBlockActive from "../../assets/images/faces_description_block_active.png";
import FacesDescriptionBlockNoActive from "../../assets/images/faces_description_block_noactive.png";
import DescriptionTitleArrow from "../../assets/images/description_title_arrow.png";
import DescriptionArrow from "../../assets/images/description_arrow.png";
import CheckMarkImg from "../../assets/images/check-mark.png";
// разметка переехала сюда со страницы описания, а стили остались там же —
// импортируем их, чтобы попап и экран выбора темы выглядели так же, как страница
import "../../pages/InsightFormNewDescriptionPage/style.scss";
import "./style.scss";

// 21.09 (решение клиента): один и тот же текст про Анкету Откровений показывается
// в трёх местах — страницей /insight-description, попапом по клику на карточку и
// на «Выбрать тему», когда карточек ещё нет. Чтобы они не разъезжались, тело
// вынесено в общий компонент. Блока «Инструкция» здесь нет — он остался
// отдельной страницей /insight-instruction.
// variant: "page" — как на /insight-description; "modal" — та же разметка, но
// собственная раскладка для попапа. Страница свёрстана под ширину 1160px и кегль
// 24px, а карточки-примеры разложены абсолютом со смещениями — в модалке это
// разъезжается, поэтому у неё отдельный набор правил (style.scss рядом).
// withFinal=false — финальный абзац рисует сам вызывающий (страница для гостя
// ставит его после инструкции, как было до 21.09)
export default function AnketaDescriptionBody({ variant = "page", withFinal = true }) {
  const { t } = useTranslation();

  return (
    <div
      className={`anketa-desc${
        variant === "modal" ? " anketa-desc--modal" : ""
      }`}
    >
      <div className="insight-form-new-description-page__subtitles">
        <div>{t("insight_form_new_description_page.subtitle1")}</div>
        <div>{t("insight_form_new_description_page.subtitle2")}</div>
      </div>
      <div className="insight-form-new-description-page__texts">
        <div>{t("insight_form_new_description_page.text1")}</div>
        <div>{t("insight_form_new_description_page.text2")}</div>
      </div>
      <div className="insight-form-new-description-page__cards_wrapper">
        <div className="insight-form-new-description-page__card">
          <div className="insight-form-new-description-page__card__content">
            <div className="insight-form-new-description-page__card__question">
              {t("insight_form_new_description_page.cards.card1")}
            </div>
            <div className="insight-form-new-description-page__card__faces_wrapper">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                <div
                  key={n}
                  className="insight-form-new-description-page__card__faces"
                >
                  <span>{n}</span>{" "}
                  <img
                    src={
                      n <= 7
                        ? FacesDescriptionBlockActive
                        : FacesDescriptionBlockNoActive
                    }
                    alt=""
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        {["card2", "card3", "card4"].map((key) => (
          <div key={key} className="insight-form-new-description-page__card">
            <div className="insight-form-new-description-page__card__content">
              <div className="insight-form-new-description-page__card__question">
                {t(`insight_form_new_description_page.cards.${key}`)}
              </div>
              <div className="insight-form-new-description-page__card__input-block">
                {t("insight_form_new_description_page.cards.my_answer")}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="insight-form-new-description-page__texts">
        <div className="insight-form-new-description-page__color_purple">
          {t("insight_form_new_description_page.text3")}
        </div>
        <div>{t("insight_form_new_description_page.text4")}</div>
        <div>{t("insight_form_new_description_page.text5")}</div>
        <div>{t("insight_form_new_description_page.text6")}</div>
        <div className="points">
          <div className="point">
            <img loading="lazy" className="small" src={CheckMarkImg} alt="" />
            {t("insight_form_new_description_page.point1")}
          </div>
          <div className="point">
            <img loading="lazy" className="small" src={CheckMarkImg} alt="" />
            {t("insight_form_new_description_page.point2")}
          </div>
        </div>
        <div>{t("insight_form_new_description_page.text7")}</div>
        <div>{t("insight_form_new_description_page.text8")}</div>
        <div className="insight-form-new-description-page__paragraph_wrapper">
          <div className="insight-form-new-description-page__subtitle_arrow">
            <img src={DescriptionTitleArrow} alt="" />{" "}
            {t("insight_form_new_description_page.paragraph.subtitle")}
          </div>
          <ul>
            <li>{t("insight_form_new_description_page.paragraph.text1")}</li>
            <li>{t("insight_form_new_description_page.paragraph.text2")}</li>
            <li>{t("insight_form_new_description_page.paragraph.text3")}</li>
            <li>{t("insight_form_new_description_page.paragraph.text4")}</li>
          </ul>
          <img
            className="insight-form-new-description-page__paragraph_arrow"
            src={DescriptionArrow}
            alt=""
          />
        </div>
        <div className="insight-form-new-description-page__color_purple">
          {t("insight_form_new_description_page.text9")}
        </div>
      </div>
      {withFinal && (
        <div className="insight-form-new-description-page__final-text">
          <div>{t("insight_form_description_page.finalText")}</div>
        </div>
      )}
    </div>
  );
}
